import { DrawerBody, Stack, Text } from '@chakra-ui/react';
import { InputFormControl } from 'features/common/components/Form';
import { TenantsByProductOptions } from 'features/common/components/TenantsByProductOptions';
import { AddEditContextIdValues } from 'features/context-ids/hooks/useAddEditContextId';
import { FormikErrors } from 'formik';

const CONTEXT_ID = 'sitecoreContextId';
const NAME = 'name';
const DESCRIPTION = 'description';

export const CreateEditContextIdDrawerBody: React.FC<{
  errors: FormikErrors<AddEditContextIdValues>;
  values: AddEditContextIdValues;
  isInEditMode: boolean;
  handleChange: (e: React.ChangeEvent<any>) => void;
  setValues: (prev: any) => any;
}> = ({ errors, values, setValues, handleChange, isInEditMode }) => (
  <DrawerBody>
    <Stack gap={5}>
      <Text>
        {isInEditMode
          ? 'You can edit the name and description.'
          : 'Select the resources you want to add to the Context ID.'}
      </Text>
      <InputFormControl
        {...{
          label: 'Context ID',
          name: CONTEXT_ID,
          value: values.sitecoreContextId,
          onChange: handleChange,
          maxW: 'xl',
          placeholder: 'Context ID will be autogenerated',
          isDisabled: true,
        }}
      />
      <InputFormControl
        {...{
          isInvalid: Boolean(errors.name),
          label: 'Name',
          name: NAME,
          value: values.name,
          onChange: handleChange,
          error: errors.name,
          maxW: 'xl',
          placeholder: 'Enter name (optional)',
        }}
      />
      <InputFormControl
        {...{
          isInvalid: Boolean(errors.description),
          label: 'Description',
          name: DESCRIPTION,
          value: values.description,
          onChange: handleChange,
          error: errors.description,
          maxW: 'xl',
          placeholder: 'Enter description (optional)',
          isTextarea: true,
        }}
      />
      {isInEditMode ? null : <TenantsByProductOptions setValues={setValues} />}
    </Stack>
  </DrawerBody>
);
